module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0125.jpg?v=3db75a55";